import React, { FC } from "react";
import { faComment } from "@fortawesome/pro-regular-svg-icons/faComment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Comment: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faComment} {...props} />
);
